import { objetoArayDeParcelas } from './objetoComArrayDeParcelas';

/**
    *! Recebe o valor total das faturas selecionadas
    *! Retorna o array com o numero total de parcelas permitidas para esse valor
    *! Sempre arredondando para mais 
**/

export function gerarNumeroParcelas(valorFatura) {
    const arrayValorInferiorCinquenta = [1];
    const multiplo = (valorFatura / 50).toString().split('.')[0];
    const primeiraParteEmNumero = Number(multiplo);

    //Se o valor da fatura é menor que 50 a primeiraParteEmNumero é 0
    if (primeiraParteEmNumero <= 1) return arrayValorInferiorCinquenta;

    return objetoArayDeParcelas[primeiraParteEmNumero] || objetoArayDeParcelas[11];
}
